"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArrayOrObject = void 0;
/*
  Give us the ability to deconstruct both arrays and objects
 I.E a hook can return [apple, setApple, apple: apple, setApple: setApple]
 which allows us to do either {apple, setApple} = hook() or [apple, setApple] = hook()
 */
function useArrayOrObject(first, second, third, props) {
    // as an array or object
    const returnedProps = [];
    Object.keys(props)
        .forEach((key) => {
        returnedProps[key] = props[key];
    });
    /*
    Because we have "useFetch", we have to overwrite the array indexes as they will
    be filled out from the "useFetch" hook after our "Object.keys" interaction.
    */
    returnedProps[0] = first;
    returnedProps[1] = second;
    returnedProps[2] = third;
    return returnedProps;
}
exports.useArrayOrObject = useArrayOrObject;
